<template>
    <div class="dropdown customDropDown">
        <button class="btnTransparent dropdown-toggle" v-bind:class="[roundedClass!='' ? roundedClass : '']" type="button" :id="'action'+uid" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" style="min-width: 95px;">
            {{set_selected_text(selectedValue)}}
        </button>
        <div class="dropdown-menu" :aria-labelledby="'action'+uid">
            <button class="dropdown-item" type="button" @click="onClickButton(item)" v-for="(item, index) in lists"
                :key="ran_inx()+index" :class="{active:item.value===selectedValue }">{{item.text}}</button>

        </div>
    </div>
</template>

<script>
 export default {
     inject: ['$validator'],
     name: 'Dropdown-element',
     props: {
         selectedValue: {
             default: ''
         },
         lists: {
             type: Array,
             default: false
         },
         roundedClass:{
            default: false
         }
     },
     data() {
         return {
             uid: this.ran_inx(),
         }
     },
     watch: {},
     computed: {},

     mounted() {},

     methods: {
         onClickButton(item) {
             this.selected_text = item.text
             this.$emit('dropselected', item)
         },
         set_selected_text(n) {
             let selected_index = this.lists.findIndex(p => p.value == n);
             if (this.lists[selected_index]) {
                  return this.lists[selected_index].text
             }else{
                 return '-----'
             }

         }

     }
 };

</script>
